export * from './IconLithologyStroked';
